// @ts-nocheck
import { del, get, patch, post } from "@insite/client-framework/Services/ApiService";
import { getWishLists } from "@insite/client-framework/Services/WishListService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface NewBuyingList {
    name: string;
    description: string;
}
export interface CreateBuyingListReturn {
    buyListId: string;
    wishListId: string;
}

export interface BuyingList {
    id: string;
    customers: { id: string }[];
    users: { id: string }[];
    wishListId: string;
    overrideBillToLists: boolean;
}

export interface UpdateBuyingListOptions {
    overrideBillToLists?: boolean | "true" | "false";
    userIds?: string[];
    customerIds?: string[];
}

const restrictedBuyingListUrl = "/api/v1/restrictedBuyingList/";

export const getAllBuyingListsAsBuyingLists = async () => {
    const response = await get<BuyingList[]>(restrictedBuyingListUrl);
    return response;
};
export const deleteBuyingList = async (buyListId: string) => {
    const deleteBuyingListEndPoint = `${restrictedBuyingListUrl}${buyListId}`;
    await del(deleteBuyingListEndPoint);
    return "success";
};
export const createBuyingList = async (newBuyingList: NewBuyingList) => {
    const response = await post<NewBuyingList, CreateBuyingListReturn>(restrictedBuyingListUrl, newBuyingList);
    return response;
};
interface UpdateBuyingListParameter extends BaseModel {
    overrideBillToLists?: boolean;
    userIds?: string[];
    customerIds?: string[];
}
export const updateBuyingList = async (buyListId: string, updateBuyingListOptions: UpdateBuyingListParameter) => {
    const updateBuyingListEndPoint = `${restrictedBuyingListUrl}${buyListId}`;
    const newBuyingList = (await patch(updateBuyingListEndPoint, updateBuyingListOptions)) as unknown as BuyingList;
    return newBuyingList;
};

export const getBuyingListByWishListId = async (wishListId: string) => {
    const getBuyingListEndPoint = `${restrictedBuyingListUrl}bywishlist/${wishListId}`;
    const response = await get<BuyingList>(getBuyingListEndPoint);
    return response;
};

export const getBuyingListById = async (buyListId: string) => {
    const getBuyingListEndPoint = `${restrictedBuyingListUrl}${buyListId}`;
    const response = await get<BuyingList>(getBuyingListEndPoint);
    return response;
};

interface WishListPagination {
    page?: number;
    pageSize?: number;
}

export const getAllBuyingListsAsWishLists = async (pagination: WishListPagination = {}) => {
    const response = await getWishLists({ additionalExpands: ["buyinglists", "wishListLineCount"], ...pagination });
    return response;
};
